import React, { Component } from "react";





class TimeslotItem extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }



  // ===============================================================================================
  onClick(e) {
    e.preventDefault();
    // console.log(`DATETIME:\n Clicked location: ${this.props.details.id} : ${this.props.details.name}`);
    if (!this.props.inactive) {
      this.props.handleClick(this.props.value);
    }
  }



  // ===============================================================================================
  render() {
    return (
      <button className={"timeslot-item" +
        ((this.props.className) ? " " + this.props.className : "") +
        ((this.props.selected) ? " timeslot-item--selected" : "") +
        ((this.props.inactive) ? " timeslot-item--inactive" : "")}
        tabIndex="-1"
        onClick={this.onClick}>

        {this.props.label}

      </button>
    );
  }

}



export default TimeslotItem
